// Utils
const resolvePortFromAPIUrl = (url: string): number => {
	try {
		const parsed = new URL(url)

		if (parsed.port) return Number(parsed.port)
		if (parsed.protocol === 'https:') return 443
		if (parsed.protocol === 'http:') return 80

		return 0
	} catch {
		return 0
	}
}

export default resolvePortFromAPIUrl
